export const busyReducer = (state = { isBusy: false }, action) => {
  switch (action.type) {
    case "APOLLO_QUERY_INIT":
      return {
        isBusy: true,
        isError: false,
        isWrite: false,
        message: "Laddar...",
      };
    case "APOLLO_QUERY_RESULT":
    case "APOLLO_QUERY_RESULT_CLIENT":
      return {
        isBusy: false,
        isError: false,
        isWrite: false,
        message: "",
      };
    case "APOLLO_QUERY_ERROR":
      return {
        isBusy: false,
        isError: true,
        isWrite: false,
        message: action.error.toString(),
      };
    case "APOLLO_MUTATION_INIT":
      return {
        isBusy: true,
        isError: false,
        isWrite: true,
        message: "Laddar...",
      };
    case "APOLLO_MUTATION_RESULT":
      return {
        isBusy: false,
        isError: false,
        isWrite: false,
        message: "",
      };
    case "APOLLO_MUTATION_ERROR":
      return {
        isBusy: false,
        isError: true,
        isWrite: false,
        message: action.error.toString(),
      };

    default:
      break;
  }

  if (action.readyState) {
    switch (action.readyState) {
      case "failure":
        return {
          isBusy: false,
          isError: true,
          isWrite: false,
          message: action.error.toString(),
        };
      case "request":
        return {
          isBusy: true,
          isError: false,
          isWrite: action.$isWrite,
          message: action.$isWrite ? "Arbetar..." : "Laddar...",
        };
      case "success":
        return {
          isBusy: false,
          isError: false,
          isWrite: false,
          message: "",
        };
      default:
        return state;
    }
  }

  return state;
};
